import { render, staticRenderFns } from "./HundredPointTable.vue?vue&type=template&id=0c01ca1c&scoped=true&"
import script from "./HundredPointTable.vue?vue&type=script&lang=js&"
export * from "./HundredPointTable.vue?vue&type=script&lang=js&"
import style0 from "./HundredPointTable.vue?vue&type=style&index=0&id=0c01ca1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01ca1c",
  null
  
)

export default component.exports